var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M679.5,349.7L151.1,9.2C119.7-7.7,83.8-6,83.8,54.7v670.6c0,55.4,38.5,64.2,67.3,45.5l528.4-340.5\n    C701.3,408,701.3,372,679.5,349.7z"}));
}

Play.defaultProps = {"viewBox":"0 0 779.7 779.7","height":"1em","width":"1em"};

module.exports = Play;

Play.default = Play;
